export const styles = {
  statusPill: {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 600,
    borderRadius: '27px',
    padding: '4px 16px',
    width: 'max-content',
  },
};
